import { ChangeAppError } from '@/shared/lib/change-app';

/**
 * Categories of federated callback failures. Each one carries a distinct
 * message and call to action, because they have different owners (error
 * communication spec): authentication failed x authorization missing x
 * service unavailable x expired return.
 */
export type CallbackErrorKind =
  | 'invalid-callback'
  | 'not-authorized'
  | 'expired'
  | 'unavailable'
  | 'failed';

/**
 * Maps a minitoken-exchange failure to a user-facing category (CA11–CA14).
 *
 * - 403 → authorization was not granted by the company (CA11)
 * - 400/401/410 → the single-use return expired or was already used (CA14)
 * - network error (status 0) / 5xx → authentication service unavailable (CA13)
 * - anything else → generic failure with a retry path
 */
export function classifyCallbackError(error: unknown): CallbackErrorKind {
  if (error instanceof ChangeAppError) {
    if (error.status === 403) return 'not-authorized';
    if ([400, 401, 410].includes(error.status)) return 'expired';
    if (error.status === 0 || error.status >= 500) return 'unavailable';
  }
  return 'failed';
}
